import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyDV7sYlZBRVZ66CZZVvd_rRT0Qh3cQlvkk',
  authDomain: 'rarity-table.firebaseapp.com',
  databaseURL: 'https://rarity-table-default-rtdb.firebaseio.com',
  projectId: 'rarity-table',
  storageBucket: 'rarity-table.appspot.com',
  messagingSenderId: '170143478099',
  appId: '1:170143478099:web:e2598d2d0248cc2e9d71a6',
  measurementId: 'G-GNSQDJ3Z6T'
};

// Firebase core
const app = initializeApp(firebaseConfig);

// Firestore for pixel persistence
export const db = getFirestore(app);

// Analytics is optional and only initialized when supported (avoids SSR issues)
export const analyticsPromise = analyticsSupported()
  .then((supported) => (supported ? getAnalytics(app) : null))
  .catch(() => null);

export default app;




